import React, {useMemo} from 'react';
import {unwrap, useStatus} from 'wave-common';
import {vehicleMakeListForYear} from 'wave-common/lib/controllers/VehicleMake';
import FirestoreDataSource from '../../data-sources/FirestoreDataSource';
import joinClassNames from '../../functions/joinClassNames';
import InvalidFeedback from './InvalidFeedback';
import PropertyInputProps from './PropertyInputProps';

export default function VehicleMakeInput({
  id,
  property,
  value,
  model,
  onChange,
  validationError,
  disabled,
}: PropertyInputProps) {
  // render

  const {
    isPending,
    error,
    value: makes,
  } = useStatus(
    React as any,
    useMemo(() => unwrap(model.year, year => vehicleMakeListForYear(year, FirestoreDataSource)), [model.year]),
  );

  return (
    <>
      <select
        name={id}
        id={id}
        value={value || ''}
        onChange={event => onChange(event.target.value)}
        className={joinClassNames(
          'custom-select',
          unwrap(validationError, error => (error ? ' is-invalid' : ' is-valid')),
        )}
        disabled={Boolean(isPending || error || !model.year || disabled)}>
        <option value="">{!model.year ? 'Select year' : property.isOptional ? 'None' : 'Select...'}</option>
        {makes?.map(make => (
          <option key={make.id} value={make.name}>
            {make.name}
          </option>
        ))}
      </select>
      <InvalidFeedback error={validationError} />
    </>
  );
}
